(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["divine-slideshow"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('[data-dps]');
  roots.forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const slides = [...root.querySelectorAll('[data-dps-slide]')];
    const dots = [...root.querySelectorAll('[data-dps-dot]')];
    const pauseButton = root.querySelector('[data-dps-pause]');
    let manualPause = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let index = 0;
    let timer;
    const loadSlide = (i) => {
      const media = slides[i]?.querySelector('.dps__media');
      const url = media?.dataset.dpsImage;
      if (!url) return;
      media.style.setProperty('--dps-image', 'url("' + url + '")');
      delete media.dataset.dpsImage;
    };
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      loadSlide(index);
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };
    const pause = () => window.clearInterval(timer);
    const start = () => {
      pause();
      if (!manualPause && !document.hidden && !root.matches(':focus-within') && !root.matches(':hover')) {
        timer = window.setInterval(() => show(index + 1), Number(root.dataset.interval) || 7000);
      }
    };
    const updatePause = () => {
      pauseButton.setAttribute('aria-pressed', String(manualPause));
      pauseButton.textContent = manualPause ? pauseButton.dataset.play : pauseButton.dataset.pause;
    };
    root.querySelector('[data-dps-prev]').addEventListener('click', () => { show(index - 1); start(); });
    root.querySelector('[data-dps-next]').addEventListener('click', () => { show(index + 1); start(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.dpsDot)); start(); }));
    pauseButton.addEventListener('click', () => { manualPause = !manualPause; updatePause(); start(); });
    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', () => window.setTimeout(start, 0));
    document.addEventListener('visibilitychange', start);
    updatePause();
    show(0);
    start();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
